export const circleCenter = { cx: 10, cy: 10 }
export const radioIconSize = { height: 20, width: 20 }
